import aa from 'search-insights'

aa('init', {
  appId: 'U4BSY5DLQ2',
  apiKey: '419789a02a88dfc3fa8d570f5e628b9f',
})

export default aa
